import { render, staticRenderFns } from "./T1BreadcrumbsPlaceholder.vue?vue&type=template&id=72bd4303&scoped=true&"
var script = {}
import style0 from "./T1BreadcrumbsPlaceholder.vue?vue&type=style&index=0&id=72bd4303&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd4303",
  null
  
)

export default component.exports